
import {Component, Mixins, Prop} from 'vue-property-decorator';
import CatalogEntryMixin from './CatalogEntryMixin.ts';

@Component
export default class CatalogItem extends Mixins(CatalogEntryMixin) {
  @Prop({default: true}) hasProgress!: boolean;
}
